import React, { useEffect, useRef, useState } from 'react'

import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { grey } from '@mui/material/colors'

function LoginFooter() {
  const StyledImg = styled('img')({})
  return (<>
    <Box sx={{ position: 'absolute', top: 'auto', bottom: 10, left: 0, right: 'auto', width: '100%', display: 'none' }}>
      <StyledImg src="/hero-header-wave-2.svg"
        sx={{ width: '50%', height: 'auto', transform: 'scaleX(-1)' }} />
    </Box>
    <Box sx={{ display: 'flex', position: 'fixed', bottom: '50px', right: '50px' }}>
      <Typography component='span' variant='h6' sx={{ fontWeight: 600, marginRight: 2 }}>
        Powered by:
      </Typography>
      <Typography component='span' variant='h6' sx={{
        fontWeight: 400, color: grey[500], marginRight: '3px'
      }}>
        Uniphore
      </Typography>
      <StyledImg src="/img/uniphore_logo.svg"
        sx={{ width: '40px', height: 'auto', marginLeft: 1 }} />
    </Box>
  </>)
}

export default LoginFooter
